// The API's error envelope carries the text at `message.detail`, so a lookup
// that accepts `message` itself hands back an object. Rendering that as a React
// child throws and takes the page down with it, so every branch here is reduced
// to a string before it is offered as one.
function messageText(value: unknown): string | null {
  if (typeof value === "string") return value || null

  if (value && typeof value === "object") {
    const detail = (value as { detail?: unknown }).detail
    if (typeof detail === "string") return detail || null
  }

  return null
}

// A caller that supplies a fallback always gets a string back.
export function getResponseMessage(data: any, defaultMessage: string): string
export function getResponseMessage(
  data: any,
  defaultMessage?: string
): string | null
export function getResponseMessage(
  data: any,
  defaultMessage?: string
): string | null {
  return (
    messageText(data?.detail) ||
    messageText(data?.message) ||
    messageText(data?.details?.message) ||
    defaultMessage ||
    null
  )
}

// DRF answers a rejected field with `{field: ["reason"]}`, which carries no
// `detail` for getResponseMessage to find.
export function firstFieldError(data: any): string | null {
  if (!data || typeof data !== "object") return null

  for (const value of Object.values(data)) {
    if (typeof value === "string") return value
    if (Array.isArray(value) && typeof value[0] === "string") return value[0]
  }
  return null
}
